import { Box, Link } from 'theme-ui'

import Type from 'src/components/gel/Type'
import { useHeaderData } from 'src/lib/react-query/queries'
import ErrorPage from 'src/components/pages/error/ErrorPage'

const ErrorFallback = () => {
  const { data: headerData } = useHeaderData()
  return (
    <ErrorPage title="Sorry, something went wrong">
      <Type variant="Labels" as="p" sx={{ pb: 13, maxWidth: 'copy' }}>
        Please try refreshing the page or come back later.
      </Type>
      <Type variant="Labels" as="h2" sx={{ pb: 6 }}>
        Useful links
      </Type>
      <Box sx={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <Link sx={{ width: ['100%', null, 'auto'] }} variant="tertiary" href="/">
          Home
        </Link>
        {headerData?.[0]?.items?.[0] ? (
          <Link
            sx={{ width: ['100%', null, 'auto'] }}
            variant="tertiary"
            href={headerData[0].items[0].url}
          >
            {headerData[0].label} - {headerData[0].items[0].label}
          </Link>
        ) : null}
        {headerData?.[1]?.items?.[0] ? (
          <Link
            sx={{ width: ['100%', null, 'auto'] }}
            variant="tertiary"
            href={headerData[1].items[0].url}
          >
            {headerData[1].label} - {headerData[1].items[0].label}
          </Link>
        ) : null}
      </Box>
    </ErrorPage>
  )
}

export default ErrorFallback
